//eslint-disable-next-line
__webpack_public_path__ = window.__wpcal_dist_url;

// As import files are hoisted "window.__wpcal_client_end = "admin";" was not running, resulted in unexpected results. Now the same code run using import "./utils/client_end_admin.js";
import "./utils/client_end_admin.js";

import Vue from "vue";
import AdminApp from "./AdminApp.vue";
import router from "./router/admin.js";
import store from "./store/admin.js";

import "./utils/common_mixin.js";
import "./utils/filters.js";
import "./utils/http.js";

import VModal from "vue-js-modal";
Vue.use(VModal, { dialog: true });

// import VCalendar from "v-calendar";
// Vue.use(VCalendar);

import DatePicker from "v-calendar/lib/components/date-picker.umd";
Vue.component("v-date-picker", DatePicker);

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import vuelidateErrorExtractor from "vuelidate-error-extractor";
import vuelidateErrorExtractorOptions from "./utils/vuelidate_error_extractor_options.js";
Vue.use(vuelidateErrorExtractor, vuelidateErrorExtractorOptions);

import VueIziToast from "vue-izitoast";
import "izitoast/dist/css/iziToast.css";
const defaultVueIziToastOptions = {
  timeout: 5000,
  position: "topRight",
  drag: false
};
Vue.use(VueIziToast, defaultVueIziToastOptions);

import AdminInfoLine from "@/components/admin/AdminInfoLine.vue";
Vue.component("AdminInfoLine", AdminInfoLine);

import PremiumInfoBadge from "@/components/admin/PremiumInfoBadge.vue";
Vue.component("PremiumInfoBadge", PremiumInfoBadge);

Vue.config.productionTip = false;

import { __, _x, _n, _nx, Tsprintf } from "@/utils/common_func.js";
Vue.prototype.__ = __;
Vue.prototype._x = _x;
Vue.prototype._n = _n;
Vue.prototype._nx = _nx;
Vue.prototype.T__ = __;
Vue.prototype.T_x = _x;
Vue.prototype.T_n = _n;
Vue.prototype.T_nx = _nx;
Vue.prototype.Tsprintf = Tsprintf;

document.addEventListener("DOMContentLoaded", () => {
  new Vue({
    router,
    store,
    render: h => h(AdminApp)
  }).$mount("#wpcal_admin_app");
});
